import { render, staticRenderFns } from "./DailyChallengeBase.vue?vue&type=template&id=7f17bd3c&scoped=true&"
import script from "./DailyChallengeBase.vue?vue&type=script&lang=ts&"
export * from "./DailyChallengeBase.vue?vue&type=script&lang=ts&"
import style0 from "./DailyChallengeBase.vue?vue&type=style&index=0&id=7f17bd3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f17bd3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7f17bd3c', component.options)
    } else {
      api.reload('7f17bd3c', component.options)
    }
    module.hot.accept("./DailyChallengeBase.vue?vue&type=template&id=7f17bd3c&scoped=true&", function () {
      api.rerender('7f17bd3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/components/DailyChallengeBase.vue"
export default component.exports